import { network } from '../lib/network';

export const UserService = {
  userLogout: () => {
    return network.post('/users/logout');
  },
  getUser: () => {
    return network.get(`/me`);
  },
  updateUserProfile: (id: string, payload: { fullName: string }) => {
    return network.post(`/users/${id}/profile`, payload);
  },
};
